/**
 * The step labels the Beaker API fills in when an author leaves the field empty.
 *
 * Copied from `AppUtils.STEP_LABEL_MAP` in the beaker repo
 * (`source/api-shared/app/utils/AppUtils.java`). A step whose label is blank in Beaker
 * still arrives with one of these in its JSON, so the front end cannot tell them apart
 * from something an author typed without knowing the list.
 *
 * These are NOT our display labels, and deliberately so: we show "Reward" where Beaker
 * defaults to "Complete", "Enter To Win" where it says "Signup". Comparing against our
 * own en-US catalog therefore only caught the handful that happened to coincide, which is
 * why most of the navigation stayed in English.
 *
 * Keep in step with the Java map. Anything missing here simply stays untranslated, the
 * behaviour before this existed, rather than breaking.
 */
export const BEAKER_DEFAULT_LABELS = {
  BUILD_YOUR_OWN: 'Build',
  COMPLETE: 'Complete',
  CUSTOM_HTML: 'Custom',
  DRAG_DROP: 'Drag & Drop',
  FB_COMMENTS: 'FB Comments',
  GALLERY: 'Gallery',
  LEAD_GEN: 'Signup',
  LISTICLE: 'List',
  PERSONALITY_QUIZ: 'Quiz',
  PINTEREST: 'Pinterest',
  POLL: 'Poll',
  PUZZLE: 'Puzzle',
  REFERRAL: 'Referral',
  SPOT_DIFFERENCE: 'Difference',
  STORE_FINDER: 'Store Finder',
  TAGBOARD: 'Tagboard',
  TEXT_TRIVIA: 'Trivia',
  UGC_PHOTO: 'Photo',
  VIDEO: 'Video',
}

export default BEAKER_DEFAULT_LABELS
